
/**
 * Creates cursor for graphql connections indicating the "after"
 * record.
 *
 * @param pageSize Size of pages
 * @param pageIndex Current page index
 */
export function getPaginationAfterCursor(pageSize: number, pageIndex: number): string {
  const skipSize = pageIndex * pageSize;
  return pageIndex > 0 ? btoa(skipSize.toString()).toString() : null;
}
